<div class="form-group">
  <label class="control-label">{{label}}</label>
  <input [(ngModel)]="model" [dpDayPicker]="timePcikerConfig" [theme]="'dp-material'" data-mode="time" data-minTime class="form-control form-control-sm" [disabled]="disabled" />
</div>
